// extracted by mini-css-extract-plugin
export var base = "footer-module--base--d2834";
export var blockQuote = "footer-module--blockQuote--45b15";
export var branding = "footer-module--branding--edb11";
export var brandingImage = "footer-module--brandingImage--87481";
export var columnLink = "footer-module--columnLink--911fa";
export var contactInfo = "footer-module--contactInfo--ba4e2";
export var container = "footer-module--container--45ab8";
export var footerBottom = "footer-module--footerBottom--45ce7";
export var footerColumns = "footer-module--footerColumns--9b38c";
export var footerContact = "footer-module--footerContact--ef71d";
export var footerCopyright = "footer-module--footerCopyright--683c0";
export var footerCopyrightLinks = "footer-module--footerCopyrightLinks--3a655";
export var footerCta = "footer-module--footerCta--31e3b";
export var footerHeading = "footer-module--footerHeading--43e4a";
export var footerSchools = "footer-module--footerSchools--b6b61";
export var footerSsHome = "footer-module--footerSsHome--5ed35";
export var gridItemFocus = "footer-module--gridItemFocus--ff4a7";
export var large = "footer-module--large--93854";
export var macro = "footer-module--macro--2b24b";
export var micro = "footer-module--micro--cacbb";
export var paragraph = "footer-module--paragraph--ac1ce";
export var responsiveTitle1 = "footer-module--responsiveTitle1--adb2c";
export var responsiveTitle2 = "footer-module--responsiveTitle2--ed6f6";
export var responsiveTitle2Orig = "footer-module--responsiveTitle2Orig--2f8a5";
export var responsiveTitle3 = "footer-module--responsiveTitle3--b1d44";
export var responsiveTitle4 = "footer-module--responsiveTitle4--23b8e";
export var responsiveTitle5 = "footer-module--responsiveTitle5--272e7";
export var responsiveTitleHuge = "footer-module--responsiveTitleHuge--f967b";
export var root = "footer-module--root--18906";
export var small = "footer-module--small--b0eb1";
export var socialIcons = "footer-module--socialIcons--4b806";
export var title1 = "footer-module--title1--23c1a";
export var title2 = "footer-module--title2--5e1dd";
export var title3 = "footer-module--title3--91906";
export var wrapper = "footer-module--wrapper--b2df9";
export var wrapperSsHome = "footer-module--wrapperSsHome--262a5";